import apiFetch from '../apiFetch'

export default function (listColorimetro, token) {
  return apiFetch({endPoint: `Recta/deleteRectaSeleccion`, method: 'POST', body: listColorimetro, token: token})
}